<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"
    :value="component_value"
    :grc_areaheight="areaheight"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" 
        :class="['grccomp_container_label', 'grccomp_container_label_top', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      >{{labeltext}}</div>
      <div ref="container_input" class="grccomp_container_input">
          <textarea ref="textinput" class="grc-input grccomp_textarea"
          v-bind:style="{ 'font-size':'15px', 'line-height':'21px', 'height': areaheight, 'border-radius':'5px', 'padding-left':'8px' }"
           v-model="display_text" 
            @input="onInput" 
            @blur="onInputBlur" 
            @focus="onInputFocus($event)" 
            @keydown="onInputKeydown"
            :readonly="readonly == 'true'"
            v-bind:placeholder="placeholder"          
          />
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'GrcTextArea',
  components:
  {

  },
  props: {
    value: String,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String,
    grc_areaheight: String,
  },
  data () {
    return {
        component_value: "",
        prev_component_value: "",

        display_text: "",
        prev_display_text: "",         

        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        areaheight: this.grc_areaheight,

        comp_focused: false
    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
          this.DisplayValue(pNewValue);
      }
    },

    display_text()
    {
        if (this.comp_focused == false) { return; }
        if (this.display_text != this.prev_display_text)
        {
            if (this.CheckText(this.display_text) == false)
            {
                this.display_text = this.prev_display_text;
            }
            else
            {
                this.prev_display_text = this.display_text;
            }
        }
    }
  },

  created: function()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }

    if (typeof this.areaheight == "undefined")
    {
      this.areaheight = "";
    }


    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }

    if (typeof this.value != "undefined")
    {
      this.prev_component_value = this.value;
      this.component_value = this.value;
      this.DisplayValue(this.component_value);
    }
    

  },
  computed: {
  },
  methods: {

    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      return CheckOK;
    },

    FormatText: function(pText)
    {
      if (pText == null) { pText = ""; }

      return pText;
    },

    onInputBlur()
    {
      if (this.IsReadonly()) 
      {
        this.$emit('grc-blur');
        this.comp_focused = false;
        return;
      }

      var s = this.FormatText(this.display_text);
      
      var ValueChanged = (s != this.prev_component_value);

      this.component_value = s;

      this.comp_focused = false;

      if (ValueChanged)
      {
        this.$emit('input', this.component_value);
      }
      else
      {
        this.prev_component_value = this.component_value;
        this.DisplayValue(this.component_value);          
      }

      this.$emit('grc-blur');

    },

    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
    },

    onInputKeydown(e)
    {
      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
      }
    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      this.DisplayValue(this.component_value);
        Vue.nextTick(function () {
            //e.target.select();
            //e.target.setSelectionRange(0, 0);
        });      
      this.$emit('grc-focus');


    },

    SetFocus()
    {
      this.$refs.textinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    SetText(pText)
    {
      this.prev_component_value = pText;
      this.component_value = pText;
      this.DisplayValue(pText);
      this.$emit('input', this.component_value);
    },

    GetText()
    {
      return this.component_value;
    }



    
  }
}
</script>

<style scoped>

</style>